import { render } from "./FavoriteSpecialistsView.vue?vue&type=template&id=0a2ca266"
import script from "./FavoriteSpecialistsView.vue?vue&type=script&lang=js"
export * from "./FavoriteSpecialistsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__